// extracted by mini-css-extract-plugin
export default {"app":"App_app__-S6I8","mainContent":"App_mainContent__gmPbb","repositoryTable":"App_repositoryTable__LchUd","detailsHello":"App_detailsHello__WVJc9"};